import { Directive, Input, HostListener, ElementRef } from '@angular/core'

@Directive({
  selector: '[appImgFallback]',
  standalone: false
})
export class ShowImageDirective {
  @Input('appImgFallback') fallbackUrl: string = ''

  constructor(private el: ElementRef) {}

  @HostListener('error')
  onError() {
    const imgElement = this.el.nativeElement as HTMLImageElement
    imgElement.src = this.fallbackUrl || 'assets/common/corrupted.jpg'
  }
}
